// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H22V22H2V2ZM4 4V6H6V4H4ZM18 4V6H20V4H18ZM20 8H18V11H20V8ZM20 13H18V16H20V13ZM20 18H18V20H20V18ZM16 13V11H8V13H16ZM6 20V18H4V20H6ZM4 16H6V13H4V16ZM4 11H6V8H4V11Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-film-1-filled')
export default class Film1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'film-1-filled',
    }
  }
}
